<template>
    <div v-animation:bottom.delay class="t-lk-competencies-item">
        <div class="t-lk-competencies-item__top">
            <div class="t-lk-competencies-item__img">
                <img v-if="item.img" :src="item.img" alt="">
            </div>
            <div
                class="t-lk-competencies-item__point"
                :class="{_1: item.status === 1, _2: item.status === 2, _3: item.status === 3}"
            ></div>
            <div
                class="t-lk-competencies-item__points t-btn-green"
                :class="{_yellow: item.moderation === 1, _red: item.moderation === 2}"
            >
                {{ item.points }}
                <div v-if="item.moderation === 2 && item.reason" class="t-form-tooltip">
                    <svg class="t-form-tooltip__svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="9" cy="9" r="6.5" stroke="#C0C0CC"/>
                        <path d="M7.16602 7.20308C7.30712 6.80195 7.58564 6.4637 7.95224 6.24825C8.31884 6.03279 8.74987 5.95403 9.16897 6.02592C9.58808 6.09781 9.96822 6.3157 10.2421 6.64101C10.5159 6.96632 10.6658 7.37805 10.6652 7.80327C10.6652 9.00366 8.86457 9.60386 8.86457 9.60386" stroke="#C0C0CC" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.91211 12.0049H8.91811" stroke="#C0C0CC" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="t-form-tooltip__container">
                        <div class="t-form-tooltip__content">{{ item.reason }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="t-lk-competencies-item__row"
            v-for="(listItem, listIndex) in item.list"
            :class="{_bottom: listIndex === item.list.length - 1}"
        >
            <div class="t-lk-competencies-item__subtitle">{{ listItem.name }}</div>
            <div class="t-lk-competencies-item__value">{{ listItem.value }}</div>
        </div>
        <div
            class="t-lk-competencies-item__btn t-btn _border-gray _lk"
            :class="{_disabled: item.moderation === 1 || !item.availableUpdate}"
            @click="checkValidate(item)"
        >
            <template v-if="item.moderation === 2">{{ $root.staticText.lk.mainEdit }}</template>
            <template v-else>{{ $root.staticText.lk.mainUpdate }}</template>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Vue from "vue";

    export default {
        name: "lk-competencies-item",
        props: ['item', 'currencies'],
        computed: {
            ...mapGetters('lk', ['profile']),
        },
        methods: {
            ...mapMutations('lk', ['setProfileItem']),
            ...mapActions('modal', ['modalType_competenciesOpen', 'modalType_missingDataOpen']),

            checkValidate(item) {
                // модалка добавить информацию
                if (this.profile.validate === 1) {
                    this.modalType_competenciesOpen({
                        title: this.$root.staticText.lk.compVendor + ' ' + item.nameVendor,
                        button: this.$root.staticText.forms.btn,
                        vendorId: item.vendorId,
                        ownerId: item.id,
                        currencies: this.currencies,
                        isEdit: true
                    });

                // модалка заполнить недостающие данные
                } else if (this.profile.validate === 2) {
                    let url = process.env.NODE_ENV !== 'production' ? 'lk/getForm.json' : 'lk/partner/getForm';
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(
                            (data) => {
                                if (data.success) {
                                    this.modalType_missingDataOpen({
                                        formInfo: data.form,
                                        button: this.$root.staticText.forms.btn,
                                        overflowNone: true,
                                    });
                                }
                            },
                            () => {}
                        );

                // заглушка, что данные на модерации
                } else if (this.profile.validate === 3) {
                    this.modalType_missingDataOpen({
                        moderateText: this.$root.staticText.lk.moderateText,
                        overflowNone: true,
                    });

                // запрос проверки profile.validate
                } else {
                    let url = process.env.NODE_ENV !== 'production' ? 'lk/isAuth.json' : 'lk/partner/check';
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(
                            (data) => {
                                this.setProfileItem({
                                    name: 'validate',
                                    value: data.success ? 1 : 2
                                });
                                this.checkValidate(item);
                            },
                            () => {}
                        );
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-competencies-item/lk-competencies-item.vue